module.exports = {"header":{"title":"Devenirun partenaire","subTitle":"HRdownloads développe activement son réseau de partenariats mutuellement bénéfiques. Notre objectif est de toujours développer des programmes qui répondent aux objectifs des deux parties en matière de valeur ajoutée pour un public que nous partageons."}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/become-partner.json
// module id = iNRU
// module chunks = 0